import React from 'react';

import Pagination from 'react-bootstrap/Pagination';
import './pagination.css';

export default class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  };
  async componentDidMount() {
	}

	componentWillUnmount() {
	}

	render() {
		const pagination = 
      Object.keys(this.props.pagination).map((e,i) => {
        return (
          <React.Fragment key={i}>
          {(() => {
            if( this.props.pagination[e].id > 0 ) {
              if (this.props.pagination[e].active==="true") {
                return (
                  <Pagination.Item onClick={(e) => {this.props.function(e)}} id={this.props.pagination[e].id} className="">{this.props.pagination[e].label}</Pagination.Item>
                )
              } else {
                return (
                  <Pagination.Item onClick={(e) => {this.props.function(e)}} id={this.props.pagination[e].id} className="" disabled>{this.props.pagination[e].label}</Pagination.Item>
                )
              }
            }
          })()}
          </React.Fragment>
        )
      })
		return (
			<Pagination>{pagination}</Pagination>
		);
	}
}
